import React, { useEffect, useState } from "react";
import {
  Button,
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
} from "reactstrap";
import { NavLink as RRNavLink } from "react-router-dom";
import { FaRegHeart, FaUserCircle } from "react-icons/fa";
import { MdOutlineShoppingCart } from "react-icons/md";
import { BiSearchAlt2 } from "react-icons/bi";
import CardCart from "../CardCart/index";
import "reset-css";
import "./NavMenu.css";
import { getData } from "../../../api/method";

const username = localStorage.getItem("username");

function NavMenu() {
  const [toggle, setToggle] = useState(false);

  const isOpen = () => {
    setToggle(true);
  };

  const [data, setData] = useState([]);
  const [dataItem, setDataItem] = useState("");

  const getCart = async () => {
    try {
      const result = await getData(`/api/Cart/user/${username}`);
      setData(result.data);
      setDataItem(result.data.length);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCart();
  }, [data]);

  const removeItem = () => {
    localStorage.removeItem("token_key");
    localStorage.removeItem("username");
    window.location.reload();
  };

  return (
    <header>
      <div className="container d-flex justify-content-between align-items-center py-4">
        <div>
          <NavbarBrand href="/" className="img_logo">
            {" "}
            Cosmetics{" "}
          </NavbarBrand>
        </div>

        <div className="d-flex align-items-center line_border">
          <Input
            className="border-0 input_u_search"
            placeholder="Enter you keyword..."
          />

          <Button className="d-flex align-items-center ms-1 btn_search">
            <BiSearchAlt2 className="t-white" />
            <span className="t-white ms-2">Search</span>
          </Button>
        </div>

        <Navbar light expand="md">
          <NavbarToggler onClick={isOpen} />

          <Collapse isOpen={toggle} navbar>
            <Nav navbar>
              {/* <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret className="d-flex align-items-center">
                  <NavLink href="/">
                    <FaRegUser />
                  </NavLink>
                </DropdownToggle>

                <DropdownMenu right className="mt-2">
                  <DropdownItem>
                    <NavLink href="/login">Login</NavLink>
                  </DropdownItem>

                  <DropdownItem>
                    <NavLink href="/register">Register</NavLink>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown> */}

              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret className="d-flex align-items-center">
                  <NavLink href="/">
                    <FaUserCircle />
                  </NavLink>
                </DropdownToggle>

                <DropdownMenu right className="mt-2">
                  <DropdownItem>
                    <NavLink href="/infomation">Infomation</NavLink>
                  </DropdownItem>

                  <DropdownItem>
                    <NavLink href="/my-order">My Order</NavLink>
                  </DropdownItem>

                  {/* <DropdownItem>
                    <NavLink href="/change-password">Change Password</NavLink>
                  </DropdownItem> */}

                  <DropdownItem>
                    <Button
                      className="btn_log_out"
                      onClick={() => removeItem()}
                    >
                      Log out
                    </Button>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>

              <NavItem className="mx-4 align-items-center d-flex">
                <NavLink href="#">
                  <FaRegHeart />
                </NavLink>
              </NavItem>

              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret className="d-flex align-items-center">
                  <NavLink href="/" className="position-relative">
                    <MdOutlineShoppingCart />
                    <span className="count_cart">{dataItem}</span>
                  </NavLink>
                </DropdownToggle>

                <DropdownMenu className="mt-2 cart_product">
                  {dataItem > 0 ? (
                    <DropdownItem>
                      <CardCart />
                    </DropdownItem>
                  ) : (
                    <DropdownItem>No products in the cart</DropdownItem>
                  )}
                </DropdownMenu>
              </UncontrolledDropdown>
            </Nav>
          </Collapse>
        </Navbar>
      </div>

      <Navbar light expand="md" className="container pt-3 pb-2">
        <NavbarToggler onClick={isOpen} />

        <Collapse isOpen={toggle} navbar className="justify-content-center">
          <Nav navbar>
            <NavItem>
              <NavLink tag={RRNavLink} to="/" className="fs-24 fw-bolder px-3">
                Home
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                tag={RRNavLink}
                to="/about-us"
                className="fs-24 fw-bolder px-3"
              >
                About Us
              </NavLink>
            </NavItem>

            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle
                nav
                caret
                className="d-flex align-items-center px-3"
              >
                <NavLink
                  tag={RRNavLink}
                  to="/categories"
                  className="fs-24 fw-bolder"
                >
                  {" "}
                  Categories{" "}
                </NavLink>
              </DropdownToggle>

              {/* <DropdownMenu right className="mt-2">
                <DropdownItem>Option 1</DropdownItem>

                <DropdownItem>Option 2</DropdownItem>

                <DropdownItem divider />

                <DropdownItem>Reset</DropdownItem>
              </DropdownMenu> */}
            </UncontrolledDropdown>

            <NavItem>
              <NavLink
                tag={RRNavLink}
                to="/blogs"
                className="fs-24 fw-bolder px-3"
              >
                Blogs
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                tag={RRNavLink}
                to="/contact-us"
                className="fs-24 fw-bolder px-3"
              >
                Contact Us
              </NavLink>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    </header>
  );
}
export default NavMenu;
